<template>
    <base-layout>
        <h1 slot="header">
            {{ `app.pages.roles` | trans}}
        </h1>

        <v-app id="vuetify-app">
            <v-container fluid pl-0 pr-0 pt-0 pb-0>
                <v-layout row wrap align-center justify-center>
                    <v-container fluid>
                        <v-layout row wrap justify-space-between>
                            <v-flex>
                                <role-form></role-form>
                            </v-flex>
                            <v-flex>
                                <permission-form></permission-form>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-flex xs12>
                        <v-data-table
                                :headers="rolesHeaders"
                                :items="permissionsItems"
                                :rows-per-page-items="[-1]"
                                class="elevation-1"
                        >
                            <template v-slot:items="props">
                                <td>{{trans('page.roles.' + props.item.name )}} ({{ props.item.name }})</td>
                                <td v-for="(perm, i) in props.item.grants" class="text-xs-center">
                                    <v-checkbox v-model="perm.granted" color="success"
                                                :title="'page.roles.' + roles[i].name | trans"
                                                class="align-center justify-center"
                                                style="height: 30px"></v-checkbox>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>

                    <v-flex xs3>
                        <v-btn @click="save" color="success" :disabled="loading" fixed bottom right fab>
                            <v-icon>save</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </base-layout>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import * as axios from 'axios';
  import { trans } from '../../../app';

  export default {

    data: () => ({
      roles: [],
      permissions: [],
      grid: [],
      loading: false,
    }),
    computed: {
      ...mapState(['dictionaries']),
      ...mapGetters(['hasPermission']),

      rolesHeaders() {
        return [
          {
            text: trans('page.roles.permission'),
            sortable: false,
          },
          ...this.roles.map(r => ({
            text: trans('page.roles.' + r.name),
            sortable: false,
          }))];
      },
      permissionsItems() {
        return this.grid;
      },
    },

    created() {
      this.fetch();

      this.$root.$on('stored', async () => await this.fetch());
    },

    methods: {
      generateGrid() {
        const items = [];
        for (const permission of this.permissions) {
          const row =
            {
              id: permission.id,
              name: permission.name,
              grants: [],
            };

          for (const role of this.roles) {
            row.grants.push({
              roleId: role.id,
              name: role.name,
              granted: role.permissions.find(p => p.id === permission.id) !== undefined,
            });
          }

          items.push(row);
        }

        return items;
      },

      async fetch() {
        try {
          const { data } = await axios({
            url: '/administrator/roles',
          });

          this.permissions = data.permissions;
          this.roles = data.roles;

          this.grid = this.generateGrid();

        } catch (error) {
          this.sentryCaptureException(error);
        }
      },

      async save() {
        try {

          this.loading = true;

          const matrix = this.roles.map(r => {
            return {
              grants: this.grid.filter(row => row.grants.filter(role => role.name === r.name && role.granted).length > 0).map(p => ({
                role_id: r.id,
                permission_id: p.id
              })),
            };
          });

          await axios({
            method: 'post',
            url: '/administrator/roles/grant',
            data: {
              matrix,
            },
          });
          this.$toast(trans('app.saved'));
        } catch (error) {
          this.sentryCaptureException(error);
        }

        this.loading = false;
      },

    },
  };
</script>

